import { render, staticRenderFns } from "./prepayments.vue?vue&type=template&id=b372586e&scoped=true&"
import script from "./prepayments.vue?vue&type=script&lang=js&"
export * from "./prepayments.vue?vue&type=script&lang=js&"
import style0 from "./prepayments.vue?vue&type=style&index=0&id=b372586e&prod&lang=scss&scoped=true&"
import style1 from "./prepayments.vue?vue&type=style&index=1&id=b372586e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b372586e",
  null
  
)

export default component.exports